// Free financial calculators page (/tools/calculators). Everything runs in the browser; results update as you type.
import '../styles/main.css';
import '../styles/features.css';
import '../styles/pricing.css';
import '../styles/planner.css';
import { applyStatic, initLanguagePicker, locale, t } from '../i18n/index.js';
import { loadToolStrings } from '../i18n/tools.js';
import { initAuth } from '../features/auth.js';
import { initNavTools } from '../ui/navTools.js';
import { growth, goal, loan, fees } from './math.js';

const eur = (d) => new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR', currencyDisplay: 'narrowSymbol', minimumFractionDigits: d, maximumFractionDigits: d });
const money = (v) => eur(0).format(Math.round(v));
const money2 = (v) => eur(2).format(v);
const pctN = (v) => v.toLocaleString(locale);
const read = (form) => Object.fromEntries([...form.elements].filter((e) => e.name).map((e) => [e.name, e.value === '' ? 0 : Number(e.value)]));
const bar = (parts) => `<div class="calc-bar">${parts.map(([v, cls, label]) => `<span class="${cls}" style="flex:${Math.max(v, 0)}" title="${label}"></span>`).join('')}</div>`;

const RENDER = {
    growth: (p) => {
        const r = growth(p);
        return `<b class="calc-big">${money(r.final)}</b><span>${t('cr.after', { n: p.years })}</span>
            ${bar([[r.contributed, 'paid', t('res.paidInCol')], [r.earned, 'earned', t('cr.growth')]])}
            <dl><dt>${t('res.paidInCol')}</dt><dd>${money(r.contributed)}</dd><dt>${t('cr.growth')}</dt><dd class="up">${money(r.earned)}</dd></dl>`;
    },
    goal: (p) => {
        const r = goal(p);
        if (r.onTrack) return `<b class="calc-big up">${t('cr.onTrack')}</b><span>${t('cr.onTrackSub', { v: money(r.fromStart) })}</span>`;
        return `<b class="calc-big">${money2(r.monthly)}</b><span>${t('cr.monthFor', { n: p.years })}</span>
            <dl><dt>${t('cr.putIn')}</dt><dd>${money(r.contributed)}</dd><dt>${t('cr.growth')}</dt><dd class="up">${money(p.target - r.contributed)}</dd></dl>`;
    },
    loan: (p) => {
        const r = loan(p);
        return `<b class="calc-big">${money2(r.payment)}</b><span>${t('cr.monthFor', { n: p.years })}</span>
            ${bar([[p.amount, 'paid', t('ca.borrowed')], [r.interest, 'interest', t('cr.interest')]])}
            <dl><dt>${t('cr.totalPaid')}</dt><dd>${money(r.total)}</dd><dt>${t('cr.ofInterest')}</dt><dd class="down">${money(r.interest)}</dd></dl>`;
    },
    fees: (p) => {
        const r = fees(p);
        return `<b class="calc-big down">${money(r.cost)}</b><span>${t('cr.feeCost', { n: p.years })}</span>
            <dl><dt>${t('cr.withA', { n: pctN(p.feeA) })}</dt><dd>${money(r.withA)}</dd><dt>${t('cr.withB', { n: pctN(p.feeB) })}</dt><dd>${money(r.withB)}</dd></dl>`;
    },
};

function update(form) {
    const kind = form.dataset.calc;
    document.querySelector(`[data-out="${kind}"]`).innerHTML = RENDER[kind](read(form));
}

loadToolStrings().then(() => {
    applyStatic();
    document.title = t('ca.pageTitle');
    initLanguagePicker();
    initNavTools();
    initAuth();
    document.querySelectorAll('form[data-calc]').forEach((form) => {
        form.addEventListener('input', () => update(form));
        form.addEventListener('submit', (e) => e.preventDefault());
        update(form);
    });
});
